import { render, staticRenderFns } from "./deleted_post_item.vue?vue&type=template&id=5f8037c9&scoped=true"
import script from "./deleted_post_item.vue?vue&type=script&lang=js"
export * from "./deleted_post_item.vue?vue&type=script&lang=js"
import style0 from "./deleted_post_item.vue?vue&type=style&index=0&id=5f8037c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8037c9",
  null
  
)

export default component.exports